import React from "react";
import {Box, Button, Grid, Typography, useMediaQuery} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {SidePanel} from "../../flippingFlyersCatalog/sidePanel";
import {useDispatch} from "react-redux";
import {toggleFlyerDetailsPopup} from "../../../store/actionCreators/toggleActionForEditorActionCreators";
import {ReactComponent as PlusIcon} from "./../../../assets/plus_icon.svg";

const useStyles = makeStyles(() => ({
    welcomeScreenWrapper: {
        height: "100%"
    },
    sidePanel: (props: any) => ({
        display: props.isSm ? `none` : `block`
        // [theme.breakpoints.down('sm')]: {
        //     display: `none`
        // }
    }),
    userControlsWrapper: {
        display: `flex`,
        flexFlow: `column`,
        height: `100%`
    },
    sidePanelForMobile: (props: any) => ({
        display: props.isSm ? `block` : "none",
        // [theme.breakpoints.down('sm')]: {
        //     display: `block`
        // }
    }),
    contentRightPanel: {
        display: `flex`,
        flexFlow: `column`,
        height: `100%`,
        padding: `0 12px 12px`,
        justifyContent: `center`,
        position: `relative`,
    },
    buttonWrapper: {
        display: `flex`,
    },
    addNewFlyer: (props: any) => ({
        '&.MuiButton-root': {
            width: props.isXs ? `100%` : `280px`,
            color: `initial`,
            backgroundColor: `#2A38BB`,
            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
            height: `48px`,
            margin: `15px 0 15px`,
            '&:hover': {
                backgroundColor: `#2A38BBCC`,
            },
            // [theme.breakpoints.down('xs')]: {
            //     width: `100%`
            // }
        }
    }),

}));


export const WelcomeScreen = () => {
    const isSm = useMediaQuery(`(max-width:899px)`);
    const isXs = useMediaQuery(`(max-width:419px)`);
    const isHSm = useMediaQuery(`(min-height:749px)`);
    const dispatch = useDispatch();
    const properties = {
        isSm: isSm,
        isXs: isXs
    };
    const classes = useStyles(properties);


    const handleClick = () => {
        dispatch(toggleFlyerDetailsPopup(true));
        // history.push(`/flipbookEditor/-1`)
    };

    return(
        <Grid container className={classes.welcomeScreenWrapper}>
            <Grid item lg={4} md={4} sm={4} className={classes.sidePanel}>
                <SidePanel/>
            </Grid>
            <Grid item xs>
                <Box
                    className={classes.userControlsWrapper}
                >
                    {
                        isHSm &&
                        <Box className={classes.sidePanelForMobile}>
                            <SidePanel/>
                        </Box>
                    }
                    <Box
                        className={classes.contentRightPanel}
                    >
                        <Box
                            className={classes.buttonWrapper}
                            justifyContent={`center`}
                        >
                            <Button
                                onClick={handleClick}
                                className={classes.addNewFlyer}
                            >
                                <PlusIcon/>
                                <Typography color={`#ffffff`} fontWeight={500} ml={`10px`}>
                                    New Flyer
                                </Typography>
                            </Button>
                        </Box>
                    </Box>

                </Box>
            </Grid>

        </Grid>
    )
}